const SECOND = 1000

export function formatDurationMs(ms: number): string {
  if (!Number.isFinite(ms) || ms < 0) return '—'
  const s = Math.round(ms / SECOND)
  if (s < 60) return `${s}s`
  const m = Math.floor(s / 60)
  const remS = s % 60
  if (m < 60) return remS === 0 ? `${m}m` : `${m}m ${String(remS).padStart(2, '0')}s`
  const h = Math.floor(m / 60)
  const remM = m % 60
  return remM === 0 ? `${h}h` : `${h}h ${remM}m`
}

/** Per-call latency: `180ms`, `1.4s`, `12s`, then delegates past a minute. */
export function formatCallDurationMs(ms: number): string {
  if (!Number.isFinite(ms) || ms <= 0) return '—'
  if (ms < SECOND) return `${Math.round(ms)}ms`
  if (ms < 10 * SECOND) {
    const rounded = Math.round(ms / 100) / 10
    if (rounded >= 10) return `${Math.round(rounded)}s`
    return `${rounded.toFixed(1)}s`
  }
  if (ms < 60 * SECOND) return `${Math.round(ms / SECOND)}s`
  return formatDurationMs(ms)
}
